import React from 'react'
import {Container, Col, Row} from 'reactstrap'

class SlicesHorizontal extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            slicesMenu: '',
        }
    }
    getSlices = () => {
        const slicesId = this.props.match.params.sliceId
        const color = this.props.match.params.color
        const location = this.props.match.params.location

        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${slicesId}`

        fetch(url)
        .then(res => res.json())
        .then(data => {
            console.log(data)
            let slices = data.menu.sections[0].items
            this.setState({
                slicesMenu: slices
            })
        })
        .catch(err => err)
    }
    componentDidMount(){
        this.getSlices()
    }
    render(){
        console.log(this.state)
        return(
            <div class="menu-board-slices-background-white slices-container">
                {this.state.slicesMenu 
                    ?
                     <div class="slice-text-container">
                        {this.state.slicesMenu.map(item => (
                            <div class="slice-item-container">
                                <div class="slice-text slice-item-name">{item.name}</div>
                                <div class="slice-text slice-item-description">{item.description}</div>
                                <div class="slice-text slice-item-price">{item.containers[0].price}</div>
                            </div>
                        ))}
                     </div>

                    :
                    <span>loading...</span>
                }

            </div>
        )
    }
}
export default SlicesHorizontal

//193806 slice menu ID
